export const DialogClassName = "RichText-Dialog"

export function eventTargetIsInDialog(event: MouseEvent | TouchEvent): boolean {
  return (
    !!event.target &&
    event.target instanceof Element &&
    !!event.target.closest(`.${DialogClassName}`)
  )
}
